module.exports = __webpack_public_path__ + "assets/img/logodetail.8acebf5d.png";